<template>
<v-card outlined rounded class="mt-4 mr-4" width="100%">
    <v-row class="align-content-start flex-wrap mr-2 ml-2" width="100%">
        <v-col>
            <p class="text-h6 text--primary mb-12">
                {{title}}
            </p>
        </v-col>
        <v-col>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-col>
    </v-row>
    <v-card-text>
        
        <v-data-table v-if="userList.length" :headers="headers" :search="search" :items="userList" @click:row="goToMemberDetails" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" :loading="isExporting">
            <template v-slot:[`item.avatar`]="{ item }">
                <v-avatar v-if="item.pictureUrl" size="32" class="mr-2">
                    <img :src="item.pictureUrl" />
                </v-avatar>
                <v-avatar v-if="!item.pictureUrl" color="info" size="32" class="mr-2">
                    <v-icon dark> mdi-account-circle </v-icon>
                </v-avatar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon class="mr-2" @click.stop="toExport(item)">
                    mdi-table-arrow-right
                </v-icon>
                <v-icon @click.stop="toDownloadWearableData(item)" v-if="wearableData.includes(item.uid)">
                    mdi-watch-variant
                </v-icon>
            </template>
        </v-data-table>
    </v-card-text>
</v-card>
</template>

<script>
import formatData from "../utils/formatData";
import bqExportData from "../data/bqExportData";
import firebase from "firebase/compat/app";
import JSZip from "jszip";

export default {
    data() {
        return {
            title: 'Member List',
            headers: [{
                    text: "",
                    value: "avatar",
                    sortable: false,
                },
                {
                    text: "Member Name",
                    value: "name",
                    cellClass: "pr-0",
                },
                {
                    text: "Start Weight",
                    value: "start_weight",
                    align: "end",
                },
                {
                    text: "End Weight",
                    value: "end_weight",
                    align: "end",
                },
                {
                    text: "Start BMI",
                    value: "start_bmi",
                    align: "end",
                },
                {
                    text: "End BMI",
                    value: "end_bmi",
                    align: "end",
                },
                {
                    text: "Start Pressure Lower",
                    value: "start_pressureLower",
                    align: "end",
                },
                {
                    text: "End Pressure Lower",
                    value: "end_pressureLower",
                    align: "end",
                },
                {
                    text: "Start Pressure Upper",
                    value: "start_pressureUpper",
                    align: "end",
                },
                {
                    text: "End Pressure Upper",
                    value: "end_pressureUpper",
                    align: "end",
                },
                {
                    text: "Start LDL",
                    value: "start_ldl",
                    align: "end",
                },
                {
                    text: "End LDL",
                    value: "end_ldl",
                    align: "end",
                },
                {
                    text: "Start FBS",
                    value: "start_fbs",
                    align: "end",
                },
                {
                    text: "End FBS",
                    value: "end_fbs",
                    align: "end",
                },
                {
                    text: "Steps",
                    value: "stepsTotal",
                    align: "end",
                },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                    width: "100px"
                },
            ],

            search: "",
            options: {
                itemsPerPage: 20,
            },
            isExporting: false,
            json_data: [],
            wearableData: [],
        };
    },
    created() {
        this.id = this.$route.params.id;
        this.toGetWearableData();
    },
    computed: {
        exportData() {
            return this.$attrs.exportData;
        },
        startDate() {
            return this.$attrs.startDate;
        },
        endDate() {
            return this.$attrs.endDate;
        },
        userList() {
            return this.$attrs.userList;
        },
        isAccessDownloadThaisookWatch() {
            return this.$store.getters.isAccessDownloadThaisookWatch;
        }
    },
    methods: {
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToMemberDetails(item) {
            localStorage.setItem('startDate', this.startDate);
            localStorage.setItem('endDate', this.endDate);
            this.$router.push(`/group/view/${this.id}/${item.uid}`);
        },
        toExport(item) {
            (async () => {
                this.isExporting = true;
                const downloadUrl = await bqExportData(this.id, this.startDate, this.endDate, item.uid);
                window.location = downloadUrl;
                this.isExporting = false;
            })();
        },
        async toGetWearableData(){
            (async () => {
                this.isExporting = true;
                try {
                    if( this.isAccessDownloadThaisookWatch ){
                        // Get reference to the Firebase Storage bucket
                        const storageRef = firebase.storage().ref();
                        // Create a reference to the subfolder
                        const folderRef = storageRef.child(`wearable_data/`);
                        const folderList = await folderRef.listAll();
                        // Get all subfolders
                        const subFolders = folderList.prefixes;
                        // Loop through each subfolder
                    
                        subFolders.forEach(async (subFolder) => {
                            this.wearableData.push(subFolder.name);
                        });
                    }
                } catch (error) {
                    console.error('Error downloading wearable data:', error);
                } finally {
                    this.isExporting = false;
                }
            })();
        },
        toDownloadWearableData(item) {
            (async () => {
                this.isExporting = true;
                try {
                    // Get reference to the Firebase Storage bucket
                    const storageRef = firebase.storage().ref();
                    // Create a reference to the subfolder
                    const folderRef = storageRef.child(`wearable_data/${item.uid}`);
                    
                    // Create a new JSZip instance
                    const zip = new JSZip();
                    
                    // Recursive function to get all files from folder and subfolders
                    const getAllFiles = async (folderRef, zipFolder = zip) => {
                        const folderList = await folderRef.listAll();
                        // console.log('Files in folder:', folderList.items);
                        // console.log('Subfolders in folder:', folderList.prefixes);
                        
                        // Add all files in current folder
                        await Promise.all(folderList.items.map(async (fileRef) => {
                            try {
                                const downloadURL = await fileRef.getDownloadURL();
                                // console.log('Downloading file:', fileRef.name, downloadURL);
                                const response = await fetch(downloadURL);
                                const blob = await response.blob();
                                zipFolder.file(fileRef.name, blob);
                            } catch (error) {
                                console.error(`Error downloading file ${fileRef.name}:`, error);
                            }
                        }));
                        
                        // Recursively process subfolders
                        await Promise.all(folderList.prefixes.map(async (subfolderRef) => {
                            try {
                                // console.log('Processing subfolder:', subfolderRef.name);
                                const subfolderZip = zipFolder.folder(subfolderRef.name);
                                await getAllFiles(subfolderRef, subfolderZip);
                            } catch (error) {
                                console.error(`Error processing subfolder ${subfolderRef.name}:`, error);
                            }
                        }));
                    };
                    
                    // Start the recursive file collection
                    await getAllFiles(folderRef);
                    
                    // Generate the zip file and force download
                    const content = await zip.generateAsync({type: "blob"});
                    
                    // Create download link
                    const url = URL.createObjectURL(content);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `wearable-data-${item.uid}.zip`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    
                    // Clean up
                    URL.revokeObjectURL(url);
                } catch (error) {
                    console.error('Error downloading wearable data:', error);
                } finally {
                    this.isExporting = false;
                }
            })();
        }
    }
};
</script>
